import { AppRouter, routes } from 'navigation';

function App() {
  return <AppRouter routes={routes} />;
}

export default App;
